import type * as Blockly from 'blockly/core';
import { indent, resolveBoard } from '@/(routers)/boards/editor/block/generators/arduino/_gen';
import { registerOledInit } from '@/(routers)/boards/editor/block/generators/arduino/blocks/display/helper/oled_init';
import { markOledUsed } from '@/(routers)/boards/editor/block/generators/arduino/blocks/display/oled_print';

export function register(gen: any): void {
    gen.forBlock['oled_bar'] = function (block: Blockly.Block): string {
        markOledUsed();

        const board = resolveBoard(block);
        const position = block.getFieldValue('POSITION') ?? 'UPPER_LEFT';

        registerOledInit(board, position);

        const value = gen.valueToCode(block, 'VALUE', 0) || '0';
        const min = gen.valueToCode(block, 'MIN', 0) || '0';
        const max = gen.valueToCode(block, 'MAX', 0) || '1023';

        // 同じスコープに複数置いても重複宣言にならないよう、ブロックごとに {} で囲む
        const varName = '_oledBarVal';

        const lines: string[] = [];

        lines.push(`float ${varName} = (float)(${value});`);
        lines.push(`oled.clearDisplay();`);
        lines.push(`oled.setTextSize(1);`);
        lines.push(`oled.setTextColor(WHITE);`);
        lines.push(`oled.setCursor(0, 0);`);
        lines.push(`oled.print(${varName});`);
        lines.push(
            `oled.fillRect(0, 8, constrain(map((long)(${varName}), (long)(${min}), (long)(${max}), 0, 128), 0, 128), 24, WHITE);`,
        );
        lines.push(`oled.display();`);

        return `{\n${indent(lines.join('\n') + '\n')}}\n`;
    };
}
